/* global axios */
import ApiClient from '../ApiClient';

/**
 * Remote MCP servers ("connectors") the account lets Tola AI call out to.
 *
 * The path is `captain/mcp_servers` because the URL surface predates the
 * Tola::AI::MCP::RemoteServer rename and stays pinned to it deliberately.
 *
 * The stored credential is write-only: the API answers with `auth_configured`
 * and never the secret, so the client can never resend one it did not just
 * type. That is why `testSaved` exists alongside `test` — probing a saved row
 * by id is the only way the stored credential gets exercised.
 */
class CaptainMcpServers extends ApiClient {
  constructor() {
    super('captain/mcp_servers', { accountScoped: true });
  }

  create(data = {}) {
    return axios.post(this.url, { mcp_server: data });
  }

  update(id, data = {}) {
    return axios.put(`${this.url}/${id}`, { mcp_server: data });
  }

  // Handshake + tool discovery for a config that does not exist yet. Nothing
  // is persisted; the response is what the remote server reports about itself.
  test(data = {}) {
    return axios.post(`${this.url}/test`, { mcp_server: data });
  }

  // Re-probe a saved connector. With no body the server probes the row exactly
  // as stored; with one, the submitted fields are overlaid on top of it.
  testSaved(id, data = null) {
    return axios.post(
      `${this.url}/${id}/test`,
      data ? { mcp_server: data } : {}
    );
  }
}

export default new CaptainMcpServers();
